/**
 * Foundation Identity — SDK API (frontend).
 *
 * Wrapper degli endpoint /api/identity/*.
 */
import { api } from "../../lib/api";

export async function searchPersonByFiscalCode(fiscalCode) {
  const { data } = await api.get("/identity/persons", {
    params: { fiscal_code: fiscalCode },
  });
  return data;
}

export async function searchPersons(query, { includeInactive = false, limit = 50 } = {}) {
  const { data } = await api.get("/identity/persons", {
    params: { q: query, include_inactive: includeInactive, limit },
  });
  return data;
}

export async function getPerson(id) {
  const { data } = await api.get(`/identity/persons/${id}`);
  return data;
}

export async function createPerson(payload) {
  const { data } = await api.post("/identity/persons", payload);
  return data;
}

export async function inviteWizard(body) {
  const { data } = await api.post("/identity/invite/wizard", body);
  return data;
}

export async function updatePerson(id, patch) {
  const { data } = await api.patch(`/identity/persons/${id}`, patch);
  return data;
}

export async function deactivatePerson(id) {
  const { data } = await api.delete(`/identity/persons/${id}`);
  return data;
}

export async function listAssignments(personId) {
  const { data } = await api.get(`/identity/persons/${personId}/assignments`);
  return data;
}

export async function addAssignment(personId, assignment) {
  const { data } = await api.post(`/identity/persons/${personId}/assignments`, assignment);
  return data;
}

export async function removeAssignment(personId, assignmentId) {
  const { data } = await api.delete(`/identity/persons/${personId}/assignments/${assignmentId}`);
  return data;
}

export async function updateAccount(personId, patch) {
  const { data } = await api.patch(`/identity/persons/${personId}/account`, patch);
  return data;
}

export async function resetAccountPassword(personId, body) {
  const { data } = await api.post(`/identity/persons/${personId}/account/reset-password`, body);
  return data;
}

export async function getPersonTimeline(personId, limit = 200) {
  const { data } = await api.get(`/identity/persons/${personId}/timeline`, { params: { limit } });
  return data;
}

export async function getPersonEmployees(personId) {
  const { data } = await api.get(`/identity/persons/${personId}/employees`);
  return data;
}

export async function linkUserToPerson(userId, body) {
  const { data } = await api.post(`/identity/users/${userId}/link-person`, body);
  return data;
}
